module.exports = __webpack_public_path__ + "img/avatar_pro.367a16cf.png";